import { useLanguage } from "../../contexts/LanguageContext";

export default function AdCard({ ad, onRemove }) {
  const { t } = useLanguage();
  return (
    <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-glass)', borderRadius: '16px', overflow: 'hidden', position: 'relative', transition: 'border-color 0.3s, transform 0.3s' }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent-cyan)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border-glass)'; e.currentTarget.style.transform = 'translateY(0)'; }}
    >
      <div style={{ height: '3px', background: 'linear-gradient(90deg, var(--accent-cyan), var(--accent-violet))' }} />
      <div style={{ padding: '20px' }}>
        <div style={{ marginBottom: '8px' }}>
          <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-muted)' }}>{t('title')}</span>
          <h2 style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)', marginTop: '2px' }}>{ad.title}</h2>
        </div>
        <div style={{ marginBottom: '16px' }}>
          <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-muted)' }}>{t('description')}</span>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '2px', lineHeight: 1.5 }}>{ad.description}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={() => onRemove(ad.ad_id)}
            style={{ padding: '8px 18px', borderRadius: '10px', border: '1px solid rgba(248,113,113,0.3)', background: 'rgba(248,113,113,0.1)', color: '#f87171', fontWeight: 600, cursor: 'pointer', fontSize: '0.8rem', transition: 'all 0.2s' }}
            onMouseEnter={e => { e.target.style.background = '#f87171'; e.target.style.color = '#fff'; }}
            onMouseLeave={e => { e.target.style.background = 'rgba(248,113,113,0.1)'; e.target.style.color = '#f87171'; }}
          >{t('remove')}</button>
        </div>
      </div>
    </div>
  );
}

